import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import LoginBackground from "./background/LoginBackground";

import * as styles from "./styles.module.scss";

/**
 * The area to the right of the login bar: an animated WebGL background with optional content on top.
 *
 * A CSS gradient shows where WebGL is not available.
 *
 * @param {Object}       props                The props.
 * @param {ReactElement} props.children       Content shown on top of the background.
 * @param {boolean}      props.withBackground Whether to show the background.
 *
 * @returns {ReactElement} The login visual.
 */
const LoginVisual = ( { children = null, withBackground = true } ) => {
	const canvasRef = useRef( null );

	useEffect( () => {
		if ( ! withBackground || ! window.matchMedia ) {
			return;
		}

		const background = new LoginBackground( canvasRef.current );
		background.start();

		return () => background.destroy();
	}, [ withBackground ] );

	return (
		<div className={ classNames( styles.visual, { [ styles.visualBackground ]: withBackground } ) }>
			{ withBackground && <canvas ref={ canvasRef } className={ styles.visualCanvas } aria-hidden="true" /> }
			{ children && <div className={ styles.visualContent }>{ children }</div> }
		</div>
	);
};

LoginVisual.propTypes = {
	children: PropTypes.node,
	withBackground: PropTypes.bool,
};

export default LoginVisual;
